import React from "react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { CONTACT } from "@/data/site";

const CONTENT = {
  "mentions-legales": {
    title: "Mentions légales",
    lines: ["Mentions", "légales"],
    sections: [
      { h: "Éditeur du site", p: `Le site ${CONTACT.brand} est édité par FuiteX, spécialiste en recherche de fuite d'eau non destructive, intervenant sur toute l'Île-de-France. Contact : ${CONTACT.email} — ${CONTACT.phoneDisplay}.` },
      { h: "Hébergement", p: "Le site est hébergé par un prestataire d'hébergement professionnel. Les coordonnées complètes de l'hébergeur seront précisées lors de la mise en ligne définitive." },
      { h: "Propriété intellectuelle", p: "L'ensemble des contenus (textes, logo, visuels) présents sur ce site sont la propriété de FuiteX, sauf mention contraire, et ne peuvent être reproduits sans autorisation." },
      { h: "Responsabilité", p: "FuiteX s'efforce d'assurer l'exactitude des informations diffusées, sans garantie d'exhaustivité. Les informations sont fournies à titre indicatif." },
    ],
  },
  "confidentialite": {
    title: "Politique de confidentialité",
    lines: ["Politique de", "confidentialité"],
    sections: [
      { h: "Collecte des données", p: "Les données que vous transmettez via le formulaire de devis (nom, téléphone, email, informations sur la fuite) sont collectées uniquement pour traiter votre demande et vous recontacter." },
      { h: "Utilisation", p: "Vos données ne sont ni vendues ni cédées à des tiers. Elles sont utilisées exclusivement dans le cadre de la relation commerciale avec FuiteX." },
      { h: "Conservation", p: "Les données sont conservées le temps nécessaire au traitement de votre demande, puis archivées ou supprimées conformément à la réglementation en vigueur." },
      { h: "Vos droits", p: `Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour l'exercer, contactez-nous à ${CONTACT.email}.` },
    ],
  },
  "cgv": {
    title: "Conditions générales de vente",
    lines: ["Conditions", "générales de vente"],
    sections: [
      { h: "Objet", p: "Les présentes conditions régissent les prestations de recherche de fuite d'eau non destructive réalisées par FuiteX." },
      { h: "Devis & tarifs", p: "Chaque intervention fait l'objet d'un devis gratuit préalable. Les tarifs sont communiqués avant toute prestation et validés par le client." },
      { h: "Intervention", p: "FuiteX met en œuvre les moyens techniques adaptés pour localiser la fuite. Un compte-rendu détaillé est remis à l'issue de l'intervention." },
      { h: "Paiement", p: "Le règlement s'effectue selon les modalités précisées sur le devis. Les conditions complètes seront finalisées lors du démarrage de la relation commerciale." },
    ],
  },
};

export default function Legal({ page }) {
  const data = CONTENT[page] || CONTENT["mentions-legales"];
  return (
    <>
      <Seo title={`${data.title} | FuiteX`} description={`${data.title} du site FuiteX, recherche de fuite d'eau en Île-de-France.`} canonical={`/${page}`} />
      <PageHero overline="Informations légales" titleLines={data.lines} breadcrumb={[{ label: data.title }]} />
      <section className="bg-white py-24">
        <div className="container-x max-w-3xl space-y-10">
          {data.sections.map((s, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <h2 className="text-2xl font-bold tracking-tight text-ink">{s.h}</h2>
              <p className="mt-3 text-lg text-ink/70 leading-relaxed">{s.p}</p>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
